<template>
  <el-dialog
    v-dialogDrag
    :title="dialogTitle"
    :visible.sync="visible"
    :close-on-click-modal="false"
    class="mid-dialog"
    :append-to-body="true"
    @close="$emit('cancel')"
  >
    <div v-loading="loading" class="w-full h-full">
      <iframe v-if="flowSrc" :src="flowSrc" frameborder="0" class="w-full h-full"></iframe>
    </div>
  </el-dialog>
</template>

<script>
import { PlanApi } from '@wiz-api/emergency-management'

const planApi = new PlanApi()
export default {
  name: 'approval-flow-dialog',
  props: {
    // visible: {
    //   type: Boolean,
    //   default: false,
    // },
    // 弹窗显隐
    // flowid: {
    //   type: String,
    //   default: '',
    // },
    // groupid: {
    //   type: String,
    //   default: '',
    // },
    id: {
      type: Number,
    },
  },
  computed: {
    // dialogVisible: {
    //   get() {
    //     return this.visible
    //   },
    //   set(val) {
    //     this.$emit('update:visible', val)
    //   },
    // },
    dialogTitle() {
      return this.$t('查看流程')
    }, // dialog标题
  },
  watch: {
    visible(val) {
      if (!val) {
        this.$emit('update:visible', val)
      }
    },
  },
  data() {
    return {
      flowSrc: '', // 嵌入流程图的地址
      flowid: '',
      groupid: '',
      loading: false,
      visible: true,
    }
  },
  methods: {
    /**
     * @description 获取iframe嵌入地址的token和ip地址
     */
    async getProcessDetail() {
      const [err, res] = await planApi.getProcess()
      if (!err) {
        this.flowSrc = `${res.apiUrl}/index.html?loadurl=${encodeURIComponent(
          `/flow/run/process?flowid=${this.flowid}&groupid=${this.groupid}&status=-1`
        )}&nroadflow-token=${res.token}&isiframe=1`
      }
    },
    async init() {
      this.loading = true
      const [err, res] = await planApi.getFlowTaskInfo({
        flowTaskId: this.id,
      })
      if (!err) {
        this.flowid = res.flowId
        this.groupid = res.groupId
      }
      await this.getProcessDetail()
      this.loading = false
    },
  },
  created() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  text-align: right;
}
::v-deep .el-tabs__content {
  height: calc(100% - 55px);
  overflow-y: auto;
}
</style>
